export default "__VITE_ASSET__DnH1jqYn__"